<div class="game-category-preview" [ngClass]="{'selected': isSelected && mode === 'teacher', 'quest-highlight': data.isQuestOfMonth}"
     (click)="onItemClicked()"
     *ngIf="data">


  <div class="game-category-preview__selected-icon" *ngIf="mode === 'teacher'">
    <brt-icon [icon]="'check-circle'"></brt-icon>
  </div>

  <div class="game-category-preview__title">{{data.categoryData.title}}</div>

  <div class="game-category-preview__icon">
    <img [src]="data.categoryData.iconPath" [alt]="data.categoryData.title">
  </div>

  <div class="game-category-preview__progress-wrapper">

    <ng-container *ngIf="!data.isQuestOfMonth; else questHighlightText">
      <div class="game-category-preview__total-progress">{{totalPoints | number:"."}} Punkte</div>
      <div class="game-category-preview__tooltip-label">
        bereits gesammelt
      </div>
    </ng-container>
    <ng-template #questHighlightText>
        <div *ngIf="data.scoreType==1">
            <div class="game-category-preview__total-progress">{{data.completedTasks}} von {{data.totalTasks}}</div>
            <div class="game-category-preview__tooltip-label">
              erledigt
            </div>
        </div>
        <div *ngIf="data.scoreType==2">
            <div class="game-category-preview__total-progress">{{data.completedPoints}} von {{data.totalPoints}}</div>
            <div class="game-category-preview__tooltip-label">
              Punkten
            </div>
        </div>
    </ng-template>

    <div class="game-category-preview__multiplier" *ngIf="!isGlobalTraining">
      <div class="game-category-preview__multiplier-icons">

        <div *ngFor="let categoryLevel of categoryLevels" class="game-category-preview__multiplier-icon"
             [ngClass]="{'active': categoryLevel.active}">
          <brt-hexagon-icon [active]="categoryLevel.active" [step]="categoryLevel.step" [quest-mode]="data.isQuestOfMonth"></brt-hexagon-icon>
          <div class="game-category-preview__multiplier-icon-value">{{categoryLevel.label}}</div>
        </div>

      </div>

<!--      <div class="game-category-preview__multiplier-label" brtTooltip [text]="'Do we need text here?'">-->
<!--        {{data.multiplier * 100}} Punkte möglich <brt-icon [icon]="'circle-infos'"></brt-icon>-->
<!--      </div>-->
      <div class="game-category-preview__multiplier-label" brtTooltip [text]="' In diesem Level kannst du maximal ' + maxPoints + ' Punkte erreichen.'">
        max. {{ maxPoints }} Punkte möglich <brt-icon [icon]="'circle-infos'"></brt-icon>
      </div>
    </div>

    <div class="game-category-preview__play-button" *ngIf="mode === 'student'">
      <brt-button [title]="isGlobalTraining ? 'Jetzt trainieren' : 'Jetzt spielen'" [color]="'white-shadow'"></brt-button>
    </div>
  </div>
</div>
